module.exports = __webpack_public_path__ + "static/vimy-aerial-beae8b21a9f068ebe52ce189cdb3d638.jpg";